import React, { useContext } from 'react'
import { AppContext } from '../../context/app'
import CustomImage from '../customImage/customImage'
import { getImage } from '../../utils/helper'
import { isEmpty } from 'lodash'
import useTemplateHook from '../template/templateHook'

const PolaroidCarouselPricingCard = ({ item, animationClass }) => {
  const { customNavigate } = useTemplateHook()
  const { accountObj } = useContext(AppContext)

  const handleRedirect = (linkObj) => {
    customNavigate('INDIRECT', linkObj)
  }

  const getStyleValue = (parentKey, childKey, defaultValue) => {
    if (!item?.style_config) {
      return defaultValue ? defaultValue : ''
    }

    let tempArr = item?.style_config[parentKey]?.data.filter((info) => info.key === childKey)

    return !isEmpty(tempArr) ? (tempArr[0].value ? tempArr[0].value : defaultValue) : defaultValue
  }

  return (
    <div className={`flex justify-center ${animationClass || ''}`}>
      <div
        className="rounded-lg overflow-hidden md:w-72 lg:w-80 xl:w-full h-[500px] sm:h-[560px] md:h-[580px] lg:h-[600px] flex flex-col"
        style={{
          background: getStyleValue('card_background', 'primary_color', '#123d70'),
          aspectRatio: '0.827938671',
        }}
      >
        {/* Image Container with Improved Aspect Ratio */}
        <div className="relative h-32 xl:h-60 w-full">
          <div className="w-full h-full relative overflow-hidden" style={{ aspectRatio: '16/9' }}>
            <CustomImage
              imageUrl={getImage(accountObj?.cf_domain_name, item?.image_s3key)}
              imgClass="absolute inset-0 w-full  object-cover"
              loaderClass={'absolute inset-0 w-full  object-cover'}
              imgAlt={`data.team1.logo`}
            />
          </div>
          <div
            className="absolute bottom-0 left-0 right-0 h-16 md:h-24 lg:h-28 xl:h-32"
            style={{
              backgroundImage: `linear-gradient(to bottom, rgba(18, 61, 112, 0),${getStyleValue(
                'card_background',
                'primary_color',
                '#123d70',
              )}  94%)`,
            }}
          ></div>
        </div>
        {/* Content */}
        <div className="px-5 flex-grow flex flex-col" style={{ width: '90%' }}>
          <h2
            className={`
              ${getStyleValue('title', 'font_format', 'font-bold')}
               mb-2 text-left text-xl md:text-2xl lg:text-3xl`}
            style={{
              fontFamily: getStyleValue('title', 'font', ''),
              color: getStyleValue('title', 'color', '#e6ff00'),
            }}
          >
            {item.title}
          </h2>
          <p
            className={`${getStyleValue('description', 'font_format', '')} text-xs mb-2 text-left`}
            style={{
              fontFamily: getStyleValue('description', 'font', ''),
              color: getStyleValue('description', 'color', '#b9b9b9'),
              fontSize: '12px',
            }}
          >
            {item.description}
          </p>
          <div className={` mb-6 text-left flex justify-start `}>
            <pre
              style={{
                whiteSpace: 'pre-wrap',
                fontFamily: getStyleValue('pragraph', 'font', 'inherit'),
                color: getStyleValue('pragraph', 'color', '#b9b9b9'),
              }}
              className={`${getStyleValue(
                'pragraph',
                'font_format',
                'font-normal',
              )} lg:text-base text-xs `}
            >
              {item?.paragraph}
            </pre>
          </div>
        </div>
        {/* Price & Button */}
        <div className="px-4 sm:px-5 pb-4 flex flex-col xl:flex-row xl:items-center xl:justify-between gap-3 xl:gap-0">
          <div
            style={{
              fontFamily: getStyleValue('pricing_text', 'font', ''),
              color: getStyleValue('pricing_text', 'color', '#ffffff'),
            }}
            className="flex items-baseline text-left md:text-lg lg:text-2xl mb-2"
          >
            <span className={`${getStyleValue('pricing_text', 'font_format', 'font-bold')}  `}>
              {item.price}
            </span>
            <span className="text-xs md:text-sm ml-1 md:ml-2">{item.period}</span>
          </div>
          <div className="flex">
            <button
              className="py-1.5 md:py-2 px-4 md:px-6 rounded-lg text-sm font-semibold"
              style={{
                backgroundImage: `linear-gradient(to ${getStyleValue(
                  'button',
                  'gradient',
                  'left',
                )}, ${getStyleValue('button', 'primary_color', '#730077')}, ${getStyleValue(
                  'button',
                  'secondary_color',
                  '#8e00ec',
                )})`,
                color: getStyleValue('button', 'text_color', '#ffffff'),
                minWidth: '160px',
              }}
              onClick={() => handleRedirect(item.link)}
            >
              {item.button_text}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PolaroidCarouselPricingCard
